/* eslint-disable no-console */
/* eslint-disable no-unused-vars */
import Vue from 'vue'
import Router from 'vue-router'
import ActivityList from './views/admin/ActivityList.vue'
import AccountEdit from './views/admin/account/_id.vue'
import AccountList from './views/admin/AccountList.vue'
import NewsEdit from './views/admin/news/Edit.vue'
import Monitoring from './views/Monitoring'
import Demand from './views/Demand'
import AirConditionerMonitoring from './views/AirConditionerMonitoring'
import AirConditionerDetail from './views/AirConditionerDetail'
import Login from './views/Login.vue'
import Realtime from './views/Realtime.vue'
import Setting from './views/Setting.vue'
import SettingDemand from './views/SettingDemand.vue'
import Top from './views/Top.vue'
import DefaultLayout from './components/layouts/Default'
import UserLayout from './components/layouts/User'
import EsUserLayout from './components/layouts/EsUser'
import AdminLayout from './components/layouts/Admin'
import ShopLayout from './components/layouts/Shop'
import ShopList from './views/admin/ShopList.vue'
import ShopComparison from './views/admin/ShopComparison.vue'
import ShopControl from './views/admin/ShopControl.vue'
import SendMail from './views/admin/SendMail.vue'
import AirConditionerSetting from './views/admin/AirConditionerSetting.vue'
import MonthlyCalendar from './views/MonthlyCalendar.vue'
import SystemDiagramSetting from './views/admin/SystemDiagramSetting.vue'
import SystemDiagramDisplay from './views/es/SystemDiagramDisplay.vue'
import StatusChangeHistory from './views/es/StatusChangeHistory.vue'
import ItemSetting from './views/admin/ItemSetting.vue'
import SystemSetting from './views/admin/SystemSetting.vue'
import CSVOutput from './views/es/CSVOutput.vue'

import Controller from './views/admin/Controller.vue'
import NInnBeppuController from './views/admin/NInnBeppuController.vue'
import ShopAggregation from './views/admin/ShopAggregation.vue'
import EsTop from './views/es/EsTop.vue'
import EsSetting from './views/es/EsSetting.vue'
import MultiCircuitGraphList from './views/es/MultiCircuitGraphList.vue'
import MultiCircuitGraphBulkChange from './views/es/MultiCircuitGraphBulkChange.vue'
import MultiCircuitGraphMaintenance from './views/es/MultiCircuitGraphMaintenance.vue'
import MultiCircuitGraph from './views/es/MultiCircuitGraph.vue'
import MultiCircuitGraphScaleGroup from './views/es/MultiCircuitGraphScaleGroup.vue'
import TroubleshootingHistory from './views/admin/TroubleshootingHistory.vue'

// import Test from './views/Test'
import NotFound from './components/NotFound'

import store from './store'
import Utils from "./utils/utils"

Vue.use(Router)

export default new Router({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes: [{
      path: '/',
      component: UserLayout,
      children: [{
          path: '',
          name: 'Top',
          component: Top,
        beforeEnter: (to, from, next) => {
            if (store.state.isLoggedIn) {
              if (Utils.isChildGroupe(store.state.loginType)) {
                if (Utils.getAccountType(store.state.loginType, store.state.functionType) == "ES") {
                  next("/es")

                } else {
                  next()
                }
              } else if (Utils.isParentGroupe(store.state.loginType)) {
                if (store.state.isConfirmed) {
                  next()
                } else {
                  next("/admin")

                }
              } else {
                next("/login")

              }
            } else {
              next("/login")
            }
          }
        },
        {
          path: 'monitoring',
          name: 'Monitoring',
          component: Monitoring,
          beforeEnter: (to, from, next) => {
            if (store.state.isLoggedIn) {
              if (Utils.isChildGroupe(store.state.loginType)) {
                if (Utils.getAccountType(store.state.loginType, store.state.functionType) == "ES") {
                  next("/es")

                } else {
                next()
                }
              } else if (Utils.isParentGroupe(store.state.loginType)) {
                if (store.state.isConfirmed) {
                  next()
                } else {
                  next("/admin")

                }
              } else {
                next("/login")

              }
            } else {
              next("/login")
            }
          }
        },
        {
          path: 'demand',
          name: 'Demand',
          component: Demand,
          beforeEnter: (to, from, next) => {
            if (store.state.isLoggedIn) {
              if (Utils.isChildGroupe(store.state.loginType)) {
                if (Utils.getAccountType(store.state.loginType, store.state.functionType) == "ES") {
                  next("/es")

                } else {
                next()
                }
              } else if (Utils.isParentGroupe(store.state.loginType)) {
                if (store.state.isConfirmed) {
                  next()
                } else {
                  next("/admin")

                }
              } else {
                next("/login")

              }
            } else {
              next("/login")
            }
          }
        },
        {
          path: 'air_conditioner_monitoring',
          name: 'AirConditionerMonitoring',
          component: AirConditionerMonitoring,
          beforeEnter: (to, from, next) => {
            if (store.state.isLoggedIn) {
              if (Utils.isChildGroupe(store.state.loginType)) {
                if (Utils.getAccountType(store.state.loginType, store.state.functionType) == "ES") {
                  next("/es")

                } else {
                next()
                }
              } else if (Utils.isParentGroupe(store.state.loginType)) {
                if (store.state.isConfirmed) {
                  next()
                } else {
                  next("/admin")

                }
              } else {
                next("/login")

              }
            } else {
              next("/login")
            }
          }
        },
        {
          path: 'air_conditioner_detail',
          name: 'AirConditionerDetail',
          component: AirConditionerDetail,
          beforeEnter: (to, from, next) => {
            if (store.state.isLoggedIn) {
              if (Utils.isChildGroupe(store.state.loginType)) {
                if (Utils.getAccountType(store.state.loginType, store.state.functionType) == "ES") {
                  next("/es")

                } else {
                next()
                }
              } else if (Utils.isParentGroupe(store.state.loginType)) {
                if (store.state.isConfirmed) {
                  next()
                } else {
                  next("/admin")

                }
              } else {
                next("/login")

              }
            } else {
              next("/login")
            }
          }
        },
        {
          path: 'realtime',
          name: 'Realtime',
          component: Realtime,
          beforeEnter: (to, from, next) => {
            if (store.state.isLoggedIn) {
              if (Utils.isChildGroupe(store.state.loginType)) {
                if (Utils.getAccountType(store.state.loginType, store.state.functionType) == "ES") {
                  next("/es")

                } else {
                next()
                }
              } else if (Utils.isParentGroupe(store.state.loginType)) {
                if (store.state.isConfirmed) {
                  next()
                } else {
                  next("/admin")

                }
              } else {
                next("/login")

              }
            } else {
              next("/login")
            }
          }
        },
        {
          path: 'setting',
          name: 'Setting',
          component: Setting,
          beforeEnter: (to, from, next) => {
            if (store.state.isLoggedIn) {
              if (Utils.isChildGroupe(store.state.loginType)) {
                if (Utils.getAccountType(store.state.loginType, store.state.functionType) == "ES") {
                  next("/es")

                } else {
                next()
                }
              } else if (Utils.isParentGroupe(store.state.loginType)) {
                if (store.state.isConfirmed) {
                  next()
                } else {
                  next("/admin")

                }
              } else {
                next("/login")

              }
            } else {
              next("/login")
            }
          }
        },
        {
          path: 'setting_demand',
          name: 'SettingDemand',
          component: SettingDemand,
          beforeEnter: (to, from, next) => {
            if (store.state.isLoggedIn) {
              if (Utils.isChildGroupe(store.state.loginType)) {
                if (Utils.getAccountType(store.state.loginType, store.state.functionType) == "ES") {
                  next("/es")

                } else {
                next()
                }
              } else if (Utils.isParentGroupe(store.state.loginType)) {
                if (store.state.isConfirmed) {
                  next()
                } else {
                  next("/admin")

                }
              } else {
                next("/login")

              }
            } else {
              next("/login")
            }
          }
        },
        {
          path: 'monthly_calendar',
          name: 'MonthlyCalendar',
          component: MonthlyCalendar,
          beforeEnter: (to, from, next) => {
            if (store.state.isLoggedIn) {
              if (Utils.isChildGroupe(store.state.loginType)) {
                if (Utils.getAccountType(store.state.loginType, store.state.functionType) == "ES") {
                  next("/es")

                } else {
                next()
                }
              } else if (Utils.isParentGroupe(store.state.loginType)) {
                if (store.state.isConfirmed) {
                  next()
                } else {
                  next("/admin")

                }
              } else {
                next("/login")

              }
            } else {
              next("/login")
            }
          }
        },
      ]
    },
    {
      path: '/es',
      component: EsUserLayout,
      children: [{
          path: '',
          name: 'EsTop',
          component: EsTop,
          beforeEnter: (to, from, next) => {
            if (store.state.isLoggedIn) {
              if (Utils.isChildGroupe(store.state.loginType)) {
                if (Utils.getAccountType(store.state.loginType, store.state.functionType) == "ES") {
                  next()

                } else {
                next("/")
                }
              } else if (Utils.isParentGroupe(store.state.loginType)) {
                if (store.state.isConfirmed) {
                  next()
                } else {
                  next("/admin")

                }
              } else {
                next("/login")

              }
            } else {
              next("/login")
            }
          }
        },
        {
          path: 'multi_circuit_graph_list',
          name: 'EsMultiCircuitGraphList',
          component: MultiCircuitGraphList,
          beforeEnter: (to, from, next) => {
            if (store.state.isLoggedIn) {
              if (Utils.isChildGroupe(store.state.loginType)) {
                if (Utils.getAccountType(store.state.loginType, store.state.functionType) == "ES") {
                  next()

                } else {
                next("/")
                }
              } else if (Utils.isParentGroupe(store.state.loginType)) {
                if (store.state.isConfirmed) {
                  next()
                } else {
                  next("/admin")

                }
              } else {
                next("/login")

              }
            } else {
              next("/login")
            }
          }
        },
        {
          path: 'multi_circuit_graph_bulk_change',
          name: 'EsMultiCircuitGraphBulkChange',
          component: MultiCircuitGraphBulkChange,
          beforeEnter: (to, from, next) => {
            if (store.state.isLoggedIn) {
              if (Utils.isChildGroupe(store.state.loginType)) {
                if (Utils.getAccountType(store.state.loginType, store.state.functionType) == "ES") {
                  next()

                } else {
                next("/")
                }
              } else if (Utils.isParentGroupe(store.state.loginType)) {
                if (store.state.isConfirmed) {
                  next()
                } else {
                  next("/admin")

                }
              } else {
                next("/login")

              }
            } else {
              next("/login")
            }
          }
        },
        {
          path: 'multi_circuit_graph_maintenance',
          name: 'EsMultiCircuitGraphMaintenance',
          component: MultiCircuitGraphMaintenance,
          beforeEnter: (to, from, next) => {
            if (store.state.isLoggedIn) {
              if (Utils.isChildGroupe(store.state.loginType)) {
                if (Utils.getAccountType(store.state.loginType, store.state.functionType) == "ES") {
                  next()

                } else {
                next("/")
                }
              } else if (Utils.isParentGroupe(store.state.loginType)) {
                if (store.state.isConfirmed) {
                  next()
                } else {
                  next("/admin")

                }
              } else {
                next("/login")

              }
            } else {
              next("/login")
            }
          }
        },
        {
          path: 'multi_circuit_graph',
          name: 'EsMultiCircuitGraph',
          component: MultiCircuitGraph,
          beforeEnter: (to, from, next) => {
            if (store.state.isLoggedIn) {
              if (Utils.isChildGroupe(store.state.loginType)) {
                if (Utils.getAccountType(store.state.loginType, store.state.functionType) == "ES") {
                  next()

                } else {
                next("/")
                }
              } else if (Utils.isParentGroupe(store.state.loginType)) {
                if (store.state.isConfirmed) {
                  next()
                } else {
                  next("/admin")

                }
              } else {
                next("/login")

              }
            } else {
              next("/login")
            }
          }
        },
        {
          path: 'multi_circuit_graph_scale_group',
          name: 'EsMultiCircuitGraphScaleGroup',
          component: MultiCircuitGraphScaleGroup,
          beforeEnter: (to, from, next) => {
            if (store.state.isLoggedIn) {
              if (Utils.isChildGroupe(store.state.loginType)) {
                if (Utils.getAccountType(store.state.loginType, store.state.functionType) == "ES") {
                  next()

                } else {
                next("/")
                }
              } else if (Utils.isParentGroupe(store.state.loginType)) {
                if (store.state.isConfirmed) {
                  next()
                } else {
                  next("/admin")

                }
              } else {
                next("/login")

              }
            } else {
              next("/login")
            }
          }
        },
        {
          path: 'system_diagram_display',
          name: 'ESSystemDiagramDisplay',
          component: SystemDiagramDisplay,
          beforeEnter: (to, from, next) => {
            if (store.state.isLoggedIn) {
              if (Utils.isChildGroupe(store.state.loginType)) {
                if (Utils.getAccountType(store.state.loginType, store.state.functionType) == "ES") {
                  next()

                } else {
                next("/")
                }
              } else if (Utils.isParentGroupe(store.state.loginType)) {
                if (store.state.isConfirmed) {
                  next()
                } else {
                  next("/admin")

                }
              } else {
                next("/login")

              }
            } else {
              next("/login")
            }
          }
        },
        {
          path: 'status_change_history',
          name: 'ESStatusChangeHistory',
          component: StatusChangeHistory,
          beforeEnter: (to, from, next) => {
            if (store.state.isLoggedIn) {
              if (Utils.isChildGroupe(store.state.loginType)) {
                if (Utils.getAccountType(store.state.loginType, store.state.functionType) == "ES") {
                  next()

                } else {
                next("/")
                }
              } else if (Utils.isParentGroupe(store.state.loginType)) {
                if (store.state.isConfirmed) {
                  next()
                } else {
                  next("/admin")

                }
              } else {
                next("/login")

              }
            } else {
              next("/login")
            }
          }
        },
        {
          path: 'csv_output',
          name: 'ESCSVOutput',
          component: CSVOutput,
          beforeEnter: (to, from, next) => {
            if (store.state.isLoggedIn) {
              if (Utils.isChildGroupe(store.state.loginType)) {
                if (Utils.getAccountType(store.state.loginType, store.state.functionType) == "ES") {
                  next()

                } else {
                next("/")
                }
              } else if (Utils.isParentGroupe(store.state.loginType)) {
                if (store.state.isConfirmed) {
                  next()
                } else {
                  next("/admin")

                }
              } else {
                next("/login")

              }
            } else {
              next("/login")
            }
          }
        },
        {
          path: 'es_setting',
          name: 'EsEsSetting',
          component: EsSetting,
          beforeEnter: (to, from, next) => {
            if (store.state.isLoggedIn) {
              if (Utils.isChildGroupe(store.state.loginType)) {
                if (Utils.getAccountType(store.state.loginType, store.state.functionType) == "ES") {
                  next()

                } else {
                next("/")
                }
              } else if (Utils.isParentGroupe(store.state.loginType)) {
                if (store.state.isConfirmed) {
                  next()
                } else {
                  next("/admin")

                }
              } else {
                next("/login")

              }
            } else {
              next("/login")
            }
          }
        },
        {
          path: 'nInnBeppuController',
          name: 'NInnBeppuController',
          component: NInnBeppuController,
          beforeEnter: (to, from, next) => {
            if (store.state.isLoggedIn) {
              if (Utils.isChildGroupe(store.state.loginType)) {
                if (Utils.getAccountType(store.state.loginType, store.state.functionType) == "ES") {
                  next()

                } else {
                next("/")
                }
              } else if (Utils.isParentGroupe(store.state.loginType)) {
                if (store.state.isConfirmed) {
                  next()
                } else {
                  next("/admin")

                }
              } else {
                next("/login")

              }
            } else {
              next("/login")
            }
          }
        },
      ]
    },
    {
      path: '/admin',
      component: AdminLayout,
      children: [{
          path: '',
          name: 'ActivityList',
          component: ActivityList,
          beforeEnter: (to, from, next) => {
            if (store.state.isLoggedIn) {
              if (Utils.isParentGroupe(store.state.loginType)) {
                next()
              } else {
                if (Utils.getAccountType(store.state.loginType, store.state.functionType) == "ES") {
                  next("/es")
                } else {
                  next("/")
                }
              }
            } else {
              next("/login")
            }
          }
        },
        {
          path: 'accountlist',
          name: 'accountList',
          component: AccountList,
          beforeEnter: (to, from, next) => {
            if (store.state.isLoggedIn) {
              if (Utils.isParentGroupe(store.state.loginType)) {
                next()
              } else {
                if (Utils.getAccountType(store.state.loginType, store.state.functionType) == "ES") {
                  next("/es")
                } else {
                  next("/")
                }
              }
            } else {
              next("/login")
            }
          }
        },
        {
          path: 'troubleshooting_history',
          name: 'TroubleshootingHistory',
          component: TroubleshootingHistory,
          beforeEnter: (to, from, next) => {
            if (store.state.isLoggedIn) {
              if (Utils.isParentGroupe(store.state.loginType)) {
                next()
              } else {
                if (Utils.getAccountType(store.state.loginType, store.state.functionType) == "ES") {
                  next("/es")
                } else {
                  next("/")
                }
              }
            } else {
              next("/login")
            }
          }
        },
        {
          path: 'item_setting/:id',
          name: 'ItemSetting',
          component: ItemSetting,
          beforeEnter: (to, from, next) => {
            if (store.state.isLoggedIn) {
              if (Utils.isParentGroupe(store.state.loginType)) {
                next()
              } else {
                if (Utils.getAccountType(store.state.loginType, store.state.functionType) == "ES") {
                  next("/es")
                } else {
                  next("/")
                }
              }
            } else {
              next("/login")
            }
          }
        },
        {
          path: 'account/:id',
          name: 'AccountEdit',
          component: AccountEdit,
          beforeEnter: (to, from, next) => {
            if (store.state.isLoggedIn) {
              if (Utils.isParentGroupe(store.state.loginType)) {
                next()
              } else {
                if (Utils.getAccountType(store.state.loginType, store.state.functionType) == "ES") {
                  next("/es")
                } else {
                  next("/")
                }
              }
            } else {
              next("/login")
            }
          }
        },
        {
          path: 'AirConditionerSetting/:id',
          name: 'AirConditionerSetting',
          component: AirConditionerSetting,
          beforeEnter: (to, from, next) => {
            if (store.state.isLoggedIn) {
              if (Utils.isParentGroupe(store.state.loginType)) {
                next()
              } else {
                if (Utils.getAccountType(store.state.loginType, store.state.functionType) == "ES") {
                  next("/es")
                } else {
                  next("/")
                }
              }
            } else {
              next("/login")
            }
          }
        },
        {
          path: 'setting_demand/:id',
          name: 'AdminSettingDemand',
          component: SettingDemand,
          beforeEnter: (to, from, next) => {
            if (store.state.isLoggedIn) {
              if (Utils.isParentGroupe(store.state.loginType)) {
                next()
              } else {
                if (Utils.getAccountType(store.state.loginType, store.state.functionType) == "ES") {
                  next("/es")
                } else {
                  next("/")
                }
              }
            } else {
              next("/login")
            }
          }
        },
        {
          path: 'news/edit',
          name: 'NewsEdit',
          component: NewsEdit,
          beforeEnter: (to, from, next) => {
            if (store.state.isLoggedIn) {
              if (Utils.isParentGroupe(store.state.loginType)) {
                next()
              } else {
                if (Utils.getAccountType(store.state.loginType, store.state.functionType) == "ES") {
                  next("/es")
                } else {
                  next("/")
                }
              }
            } else {
              next("/login")
            }
          }
        },
        {
          path: 'system_diagram_setting/:id',
          name: 'SystemDiagramSetting',
          component: SystemDiagramSetting,
          beforeEnter: (to, from, next) => {
            if (store.state.isLoggedIn) {
              if (Utils.isParentGroupe(store.state.loginType)) {
                next()
              } else {
                if (Utils.getAccountType(store.state.loginType, store.state.functionType) == "ES") {
                  next("/es")
                } else {
                  next("/")
                }
              }
            } else {
              next("/login")
            }
          }
        },
        {
          path: 'controller',
          name: 'Controller',
          component: Controller,
          beforeEnter: (to, from, next) => {
            if (store.state.isLoggedIn) {
              if (Utils.isParentGroupe(store.state.loginType)) {
                next()
              } else {
                if (Utils.getAccountType(store.state.loginType, store.state.functionType) == "ES") {
                  next("/es")
                } else {
                  next("/")
                }
              }
            } else {
              next("/login")
            }
          }
        },
        {
          path: 'multi_circuit_graph_list',
          name: 'AdminMultiCircuitGraphList',
          component: MultiCircuitGraphList,
          beforeEnter: (to, from, next) => {
            if (store.state.isLoggedIn) {
              if (Utils.isParentGroupe(store.state.loginType)) {
                next()
              } else {
                if (Utils.getAccountType(store.state.loginType, store.state.functionType) == "ES") {
                  next("/es")
                } else {
                  next("/")
                }
              }
            } else {
              next("/login")
            }
          }
        },
        {
          path: 'multi_circuit_graph_bulk_change',
          name: 'AdminMultiCircuitGraphBulkChange',
          component: MultiCircuitGraphBulkChange,
          beforeEnter: (to, from, next) => {
            if (store.state.isLoggedIn) {
              if (Utils.isParentGroupe(store.state.loginType)) {
                next()
              } else {
                if (Utils.getAccountType(store.state.loginType, store.state.functionType) == "ES") {
                  next("/es")
                } else {
                  next("/")
                }
              }
            } else {
              next("/login")
            }
          }
        },
        {
          path: 'multi_circuit_graph_maintenance',
          name: 'AdminMultiCircuitGraphMaintenance',
          component: MultiCircuitGraphMaintenance,
          beforeEnter: (to, from, next) => {
            if (store.state.isLoggedIn) {
              if (Utils.isParentGroupe(store.state.loginType)) {
                next()
              } else {
                if (Utils.getAccountType(store.state.loginType, store.state.functionType) == "ES") {
                  next("/es")
                } else {
                  next("/")
                }
              }
            } else {
              next("/login")
            }
          }
        },
        {
          path: 'multi_circuit_graph',
          name: 'AdminMultiCircuitGraph',
          component: MultiCircuitGraph,
          beforeEnter: (to, from, next) => {
            if (store.state.isLoggedIn) {
              if (Utils.isParentGroupe(store.state.loginType)) {
                next()
              } else {
                if (Utils.getAccountType(store.state.loginType, store.state.functionType) == "ES") {
                  next("/es")
                } else {
                  next("/")
                }
              }
            } else {
              next("/login")
            }
          }
        },
        {
          path: 'multi_circuit_graph_scale_group',
          name: 'AdminMultiCircuitGraphScaleGroup',
          component: MultiCircuitGraphScaleGroup,
          beforeEnter: (to, from, next) => {
            if (store.state.isLoggedIn) {
              if (Utils.isParentGroupe(store.state.loginType)) {
                next()
              } else {
                if (Utils.getAccountType(store.state.loginType, store.state.functionType) == "ES") {
                  next("/es")
                } else {
                  next("/")
                }
              }
            } else {
              next("/login")
            }
          }
        },
        {
          path: 'es_setting',
          name: 'AdminEsSetting',
          component: EsSetting,
          beforeEnter: (to, from, next) => {
            if (store.state.isLoggedIn) {
              if (Utils.isParentGroupe(store.state.loginType)) {
                next()
              } else {
                if (Utils.getAccountType(store.state.loginType, store.state.functionType) == "ES") {
                  next("/es")
                } else {
                  next("/")
                }
              }
            } else {
              next("/login")
            }
          }
        },
        {
          path: 'system_setting',
          name: 'SystemSetting',
          component: SystemSetting,
          beforeEnter: (to, from, next) => {
            if (store.state.isLoggedIn) {
              if (Utils.isParentGroupe(store.state.loginType)) {
                next()
              } else {
                if (Utils.getAccountType(store.state.loginType, store.state.functionType) == "ES") {
                  next("/es")
                } else {
                  next("/")
                }
              }
            } else {
              next("/login")
            }
          }
        },
      ]
    },
    {
      path: '/shop',
      component: ShopLayout,
      children: [{
        path: '',
        name: 'shop_list',
        component: ShopList,
        beforeEnter: (to, from, next) => {
          if (store.state.isLoggedIn) {
            if (Utils.isParentGroupe(store.state.loginType)) {
              next()
            } else {
              if (Utils.getAccountType(store.state.loginType, store.state.functionType) == "ES") {
                next("/es")
              } else {
                next("/")
              }
            }
          } else {
            next("/login")
          }
        }
      },
      {
        path: 'shop_comparison',
        name: 'shop_comparison',
        component: ShopComparison,
        beforeEnter: (to, from, next) => {
          if (store.state.isLoggedIn) {
            if (Utils.isParentGroupe(store.state.loginType)) {
              next()
            } else {
              if (Utils.getAccountType(store.state.loginType, store.state.functionType) == "ES") {
                next("/es")
              } else {
                next("/")
              }
            }
          } else {
            next("/login")
          }
        }
      },
        {
          path: 'shop_control',
          name: 'shop_control',
          component: ShopControl,
          beforeEnter: (to, from, next) => {
            if (store.state.isLoggedIn) {
              if (Utils.isParentGroupe(store.state.loginType)) {
                next()
              } else {
                if (Utils.getAccountType(store.state.loginType, store.state.functionType) == "ES") {
                  next("/es")
                } else {
                  next("/")
                }
              }
            } else {
              next("/login")
            }
          }
        },
        {
          path: 'send_mail',
          name: 'send_mail',
          component: SendMail,
          beforeEnter: (to, from, next) => {
            if (store.state.isLoggedIn) {
              if (Utils.isParentGroupe(store.state.loginType)) {
                next()
              } else {
                if (Utils.getAccountType(store.state.loginType, store.state.functionType) == "ES") {
                  next("/es")
                } else {
                  next("/")
                }
              }
            } else {
              next("/login")
            }
          }
        },
        {
          path: 'shop_aggregation',
          name: 'ShopAggregation',
          component: ShopAggregation,
          beforeEnter: (to, from, next) => {
            if (store.state.isLoggedIn) {
              if (Utils.isParentGroupe(store.state.loginType)) {
                next()
              } else {
                if (Utils.getAccountType(store.state.loginType, store.state.functionType) == "ES") {
                  next("/es")
                } else {
                  next("/")
                }
              }
            } else {
              next("/login")
            }
          }
        },
        {
          path: 'multi_circuit_graph_list',
          name: 'ShopMultiCircuitGraphList',
          component: MultiCircuitGraphList,
          beforeEnter: (to, from, next) => {
            if (store.state.isLoggedIn) {
              if (Utils.isParentGroupe(store.state.loginType)) {
                next()
              } else {
                if (Utils.getAccountType(store.state.loginType, store.state.functionType) == "ES") {
                  next("/es")
                } else {
                  next("/")
                }
              }
            } else {
              next("/login")
            }
          }
        },
        {
          path: 'multi_circuit_graph_bulk_change',
          name: 'ShopMultiCircuitGraphBulkChange',
          component: MultiCircuitGraphBulkChange,
          beforeEnter: (to, from, next) => {
            if (store.state.isLoggedIn) {
              if (Utils.isParentGroupe(store.state.loginType)) {
                next()
              } else {
                if (Utils.getAccountType(store.state.loginType, store.state.functionType) == "ES") {
                  next("/es")
                } else {
                  next("/")
                }
              }
            } else {
              next("/login")
            }
          }
        },
        {
          path: 'multi_circuit_graph_maintenance',
          name: 'ShopMultiCircuitGraphMaintenance',
          component: MultiCircuitGraphMaintenance,
          beforeEnter: (to, from, next) => {
            if (store.state.isLoggedIn) {
              if (Utils.isParentGroupe(store.state.loginType)) {
                next()
              } else {
                if (Utils.getAccountType(store.state.loginType, store.state.functionType) == "ES") {
                  next("/es")
                } else {
                  next("/")
                }
              }
            } else {
              next("/login")
            }
          }
        },
        {
          path: 'multi_circuit_graph',
          name: 'ShopMultiCircuitGraph',
          component: MultiCircuitGraph,
          beforeEnter: (to, from, next) => {
            if (store.state.isLoggedIn) {
              if (Utils.isParentGroupe(store.state.loginType)) {
                next()
              } else {
                if (Utils.getAccountType(store.state.loginType, store.state.functionType) == "ES") {
                  next("/es")
                } else {
                  next("/")
                }
              }
            } else {
              next("/login")
            }
          }
        },
        {
          path: 'multi_circuit_graph_scale_group',
          name: 'ShopMultiCircuitGraphScaleGroup',
          component: MultiCircuitGraphScaleGroup,
          beforeEnter: (to, from, next) => {
            if (store.state.isLoggedIn) {
              if (Utils.isParentGroupe(store.state.loginType)) {
                next()
              } else {
                if (Utils.getAccountType(store.state.loginType, store.state.functionType) == "ES") {
                  next("/es")
                } else {
                  next("/")
                }
              }
            } else {
              next("/login")
            }
          }
        },
        {
          path: 'es_setting',
          name: 'ShopEsSetting',
          component: EsSetting,
          beforeEnter: (to, from, next) => {
            if (store.state.isLoggedIn) {
              if (Utils.isParentGroupe(store.state.loginType)) {
                next()
              } else {
                if (Utils.getAccountType(store.state.loginType, store.state.functionType) == "ES") {
                  next("/es")
                } else {
                  next("/")
                }
              }
            } else {
              next("/login")
            }
          }
        },
      ]
    },
    {
      path: '/login',
      component: DefaultLayout,
      children: [{
        path: '',
        name: 'Login',
        component: Login,
      }],
    },
    // {
    //   path: '/test',
    //   name: 'Test',
    //   component: DefaultLayout,
    //   children: [{
    //     path: '',
    //     component: Test,
    //   }],
    // },
    {
      path: '*',
      component: DefaultLayout,
        children: [{
          path: '',
          component: NotFound,
        }],
    }

  ]
})